import { createActions, createReducer } from "reduxsauce"
import * as Immutable from "seamless-immutable"
// import * as R from 'ramda';

/* ------------- Types and Action Creators ------------- */
// const tag = '[SAGA_CONTACT_REDUX]'; // eslint-disable-line

const functionDefinitions = {
  /*---------- getProvinces --------*/

  requestGetProvinces: [],
  getProvincesSuccess: ["getProvincesResponse"],
  getProvincesFailure: ["getProvincesError"],
  /*---------- getDistrictByProvinceId --------*/

  requestGetDistrictByProvinceId: ["ProvinceId"],
  getDistrictByProvinceIdSuccess: ["getDistrictByProvinceIdResponse"],
  getDistrictByProvinceIdFailure: ["getDistrictByProvinceIdError"],

  /*---------- getSubDistrictByDistrictId --------*/

  requestGetSubDistrictByDistrictId: ["DistrictId"],
  getSubDistrictByDistrictIdSuccess: ["getSubDistrictByDistrictIdResponse"],
  getSubDistrictByDistrictIdFailure: ["getSubDistrictByDistrictIdError"]
}

const { Types, Creators } = createActions(functionDefinitions)

export const SagaMapTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const SagaMapInitState = {
  MapDetail: []
}

export const INITIAL_STATE = Immutable(SagaMapInitState)

/* ------------- Reducers ------------- */

/*---------- getProvinces --------*/

export const requestGetProvinces = (state: Immutable) => {
  return state.merge({
    getProvincesFetching: true
  })
}
export const getProvincesSuccess = (state: Immutable, action) => {
  return state.merge({
    getProvincesFetching: false,
    getProvincesResponse: action.getProvincesResponse
  })
}
export const getProvincesFailure = (state: Immutable, action) => {
  return state.merge({
    getProvincesFetching: false,
    getProvincesError: action.getProvincesError
  })
}

/*---------- getDistrictByProvinceId --------*/

export const requestGetDistrictByProvinceId = (state: Immutable, action) => {
  return state.merge({
    getDistrictByProvinceIdFetching: true,
    ProvinceId: action.ProvinceId
  })
}
export const getDistrictByProvinceIdSuccess = (state: Immutable, action) => {
  return state.merge({
    getDistrictByProvinceIdFetching: false,
    getDistrictByProvinceIdResponse: action.getDistrictByProvinceIdResponse
  })
}
export const getDistrictByProvinceIdFailure = (state: Immutable, action) => {
  return state.merge({
    getDistrictByProvinceIdFetching: false,
    getDistrictByProvinceIdError: action.getDistrictByProvinceIdError
  })
}

/*---------- getSubDistrictByDistrictId --------*/

export const requestGetSubDistrictByDistrictId = (state: Immutable, action) => {
  return state.merge({
    getSubDistrictByDistrictIdFetching: true,
    DistrictId: action.DistrictId
  })
}
export const getSubDistrictByDistrictIdSuccess = (state: Immutable, action) => {
  return state.merge({
    getSubDistrictByDistrictIdFetching: false,
    getSubDistrictByDistrictIdResponse:
      action.getSubDistrictByDistrictIdResponse
  })
}
export const getSubDistrictByDistrictIdFailure = (state: Immutable, action) => {
  return state.merge({
    getSubDistrictByDistrictIdFetching: false,
    getSubDistrictByDistrictIdError: action.getSubDistrictByDistrictIdError
  })
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  /*---------- getProvinces --------*/

  [Types.REQUEST_GET_PROVINCES]: requestGetProvinces,
  [Types.GET_PROVINCES_SUCCESS]: getProvincesSuccess,
  [Types.GET_PROVINCES_FAILURE]: getProvincesFailure,
  /*---------- getDistrictByProvinceId --------*/

  [Types.REQUEST_GET_DISTRICT_BY_PROVINCE_ID]: requestGetDistrictByProvinceId,
  [Types.GET_DISTRICT_BY_PROVINCE_ID_SUCCESS]: getDistrictByProvinceIdSuccess,
  [Types.GET_DISTRICT_BY_PROVINCE_ID_FAILURE]: getDistrictByProvinceIdFailure,

  /*---------- getSubDistrictByDistrictId --------*/

  [Types.REQUEST_GET_SUB_DISTRICT_BY_DISTRICT_ID]: requestGetSubDistrictByDistrictId,
  [Types.GET_SUB_DISTRICT_BY_DISTRICT_ID_SUCCESS]: getSubDistrictByDistrictIdSuccess,
  [Types.GET_SUB_DISTRICT_BY_DISTRICT_ID_FAILURE]: getSubDistrictByDistrictIdFailure
})



// WEBPACK FOOTER //
// ./src/redux/sagaMap/sagaMapRedux.ts